/** Must match the API's CSRF_COOKIE_NAME (staging sets both, e.g. csrftoken_staging). */
export const CSRF_COOKIE_NAME = import.meta.env?.VITE_CSRF_COOKIE_NAME?.trim() || 'csrftoken'

/**
 * Value of cookie `name` in a `document.cookie` string, or '' when absent.
 *
 * A browser can hold two cookies with the same name (e.g. `.talentco.io` and
 * `.staging.talentco.io`). Django keeps the last one it parses from the Cookie header,
 * and browsers order `document.cookie` the same way, so the last non-empty value is the
 * one the CSRF check compares against.
 */
export function readCookie(cookieString: string, name: string): string {
  let found = ''
  for (const chunk of cookieString.split(';')) {
    const eq = chunk.indexOf('=')
    if (eq === -1 || chunk.slice(0, eq).trim() !== name) continue
    const value = chunk.slice(eq + 1).trim()
    if (value) found = value
  }
  return found
}

export function readCsrfTokenFromCookie(): string {
  if (typeof document === 'undefined') return ''
  return readCookie(document.cookie, CSRF_COOKIE_NAME)
}
